import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { threadsBackend } from './threads.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { threadsReducer } from './threads.reducer';

// FIXME: remove that
backend.threads = threadsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('threads', threadsReducer),
    /* DatastoreBackendModule.forFeature(
      'threads',
      threadsBackend,
    ),*/
  ],
})
export class DatastoreThreadsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/threads/threads.module.ts